import { render, staticRenderFns } from "./CheckListView.vue?vue&type=template&id=652dfdd9&"
import script from "./CheckListView.vue?vue&type=script&lang=ts&"
export * from "./CheckListView.vue?vue&type=script&lang=ts&"
import style0 from "./CheckListView.vue?vue&type=style&index=0&id=652dfdd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports